import styled from "styled-components";

export const Article = styled.article`
  margin: ${({ theme }) => theme.margin} 0;
`;
